import { Link } from "@inertiajs/react"
import { TableCell } from "@/components/ui/table"
import { STATUS_CONFIG, projectShowPath } from "@/lib/project-configs"
import type { Project } from "@/types"

export function ProjectNameCell({ project, navKey }: { project: Project; navKey?: string }) {
  const statusCfg = STATUS_CONFIG[project.status]
  const StatusIcon = statusCfg?.icon
  const score = project.lead_score ?? 0
  const scoreColor = score <= 3 ? "#ef4444" : score <= 6 ? "#f59e0b" : "#22c55e"

  return (
    <TableCell>
      <div className="flex items-center gap-2">
        {StatusIcon && (
          <span title={`Score ${score}/10`}>
            <StatusIcon className="size-5 shrink-0" style={{ color: scoreColor }} />
          </span>
        )}
        <div className="flex flex-col">
          <Link href={projectShowPath(project, navKey)} className="font-medium hover:underline">
            {project.name}
          </Link>
          <span className="text-muted-foreground text-xs">
            {[project.address, project.city_name, project.zip_code].filter(Boolean).join(", ") || "—"}
          </span>
        </div>
      </div>
    </TableCell>
  )
}
